<!-- 暂时未使用的组件，使用后记得删除此行，顺便调试&优化下代码 -->
<template>
  <div
    class="test_box m-b-10"
    :contenteditable="editable"
    v-html="sentence.peTextShow"
    :key="sentence.peTextShow"
    @input="handleInput($event)"
    @blur="blurText($event)"
    @focus="focusText($event)"
    :id="`a${sentence.id}`"
  ></div>
</template>

<script>
import Vue from 'vue';
import { lowCheck } from '@/api/qc/qcflow';
export default {
  props: {
    editable: {
      type: Boolean,
      default: true,
    },
    sentence: {
      type: Object,
    },
    taskId: String,
  },
  data() {
    return {
      value: 0,
      content: '',
    };
  },
  methods: {
    handleInput(e) {
      this.value = e.target.innerText;
    },
    // 获取焦点
    focusText(e) {
      this.value = e.target.innerText;
    },
    // 失去焦点
    blurText() {
      const { id, srcText } = this.sentence;
      lowCheck(
        Object.assign({
          srcText: srcText,
          sentId: id,
          operateQcTaskId: this.taskId,
          peText: this.value,
        }),
      ).then((res) => {
        // 有错误
        if (res.data.data.length > 0) {
          let result = res.data.data;
          this.replaceContent(result);
        } else {
          // 空状态重置下，否则无法清除报错
          document.querySelector(`#a${this.sentence.id}`).innerHTML =
            this.sentence.peText;
        }
      });
    },
    replaceContent(result) {
      let elements = this.generateNewElements(result);
      // 挂载组件，即创建虚拟dom。
      elements.$mount(`#a${this.sentence.id}`);
    },
    generateNewElements(result) {
      const _this = this;
      const TagClass = Vue.extend({
        // 向界面渲染的dom方法。
        render(createElement) {
          return createElement(
            'div',
            {
              attrs: {
                contenteditable: true,
                id: `a${_this.sentence.id}`,
              },
              class: 'test_box m-b-10',
              on: {
                input: (e) => {
                  _this.handleInput(e);
                },
                focus: (e) => {
                  _this.focusText(e);
                },
                blur: (e) => {
                  _this.blurText(e);
                },
              },
            },
            result.map((it) => {
              if (it.tooltip !== '') {
                return createElement(
                  'el-tooltip',
                  {
                    attrs: {
                      content: it.tooltip,
                      'hide-after': 3000,
                      placement: 'top',
                    },
                  },
                  [
                    createElement(
                      'span',
                      {
                        class: {
                          'flow-wave': true,
                        },
                      },
                      it.text,
                    ),
                  ],
                );
              } else {
                return createElement('span', it.text);
              }
            }),
          );
        },
      });
      return new TagClass();
    },
  },
};
</script>
